import LivestockShrinkList from './LivestockShrinkList'

export default LivestockShrinkList
